import {Component, Inject, inject} from '@angular/core';
import {MAT_SNACK_BAR_DATA, MatSnackBarRef} from "@angular/material/snack-bar";
import {FlagType} from "../utils/enums";


interface FlagModel {
  message: string,
  type: FlagType
}
@Component({
  selector: 'app-custom-flag',
  templateUrl: './custom-flag.component.html',
  styleUrl: './custom-flag.component.scss'
})
export class CustomFlagComponent {
  snackBarRef = inject(MatSnackBarRef);
  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: FlagModel) { }
}
